import { wordPressRequest } from "./wordpress";
import "./users/forgot-password";

(function () {
	const isLoggedIn = checkLoggedIn();

	if (isLoggedIn) {
		document.querySelectorAll("[data-user-logout]").forEach((btn) => {
			btn.addEventListener("click", (e) => {
				e.target.disabled = true;

				let logout = logoutRequest();
			});
		});
	} else {
		document.getElementById("form-login").addEventListener("submit", (e) => {
			e.preventDefault();

			const form = e.target;
			const user = e.target.querySelector('[name="username"]').value;
			const pw = e.target.querySelector('[name="password"]').value;

			let request = loginRequest(user, pw, form);
		});

		document.getElementById("form-forgot").addEventListener("submit", (e) => {
			e.preventDefault();

			const form = e.target;
			const user = e.target.querySelector('[name="username"]').value;

			let request = forgotRequest(user, form);
		});

		document.getElementById("form-register").addEventListener("submit", (e) => {
			e.preventDefault();

			const form = e.target;
			const email = e.target.querySelector('[name="email"]').value;
			const name = e.target.querySelector('[name="name"]').value;

			let request = registerUserRequest(name, email, form);
		});
	}

	function checkLoggedIn() {
		let isLoggedIn;
		isLoggedIn = getCookie("acc_user_login");

		return isLoggedIn;
	}

	function registerUserRequest(name, email, form) {
		const url = phpVals.adminAjax;
		const recaptchaResponse = form.querySelector('[name="g-recaptcha-response"]').value;

		// Setup formdata
		let data = new FormData();
		data.append("action", "bt_user_register");
		data.append("nonce", phpVals.btNonce);
		data.append("name", name);
		data.append("email", email);
		data.append("g-recaptcha-response", recaptchaResponse);

		const params = new URLSearchParams(data);

		// Disable form controls and show loader
		toggleFormControls(form);

		clearFormError(form);

		wordPressRequest("POST", url, params)
			.then((data) => {
				if (data?.api_response !== "error") {
					// User has registered
					setFormSuccess(form, { ariaDescribedBy: "error-message" }, "Registered! Check your email for a confirmation link.");
				} else {
					// The login has returned an error, let's handle it
					console.error(data);

					toggleFormControls(form);
					setFormErrors(form, { ariaDescribedBy: "error-message" }, data.message);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	}

	function forgotRequest(user, form) {
		const url = phpVals.adminAjax;

		// Setup formdata
		let data = new FormData();
		data.append("action", "bt_user_forgot");
		data.append("nonce", phpVals.btNonce);
		data.append("user", user);

		const params = new URLSearchParams(data);

		// Disable form controls and show loader
		toggleFormControls(form);

		clearFormError(form);

		wordPressRequest("POST", url, params)
			.then((data) => {
				if (data.api_response !== "error") {
					// User has logged in
					setFormSuccess(form, { ariaDescribedBy: "error-message" }, data.message);
				} else {
					// The login has returned an error, let's handle it
					console.error(data);

					toggleFormControls(form);
					setFormErrors(form, { ariaDescribedBy: "error-message" }, data.message);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	}

	function loginRequest(user, pw, form) {
		const url = phpVals.adminAjax;

		// Setup formdata
		let data = new FormData();
		data.append("action", "bt_user_login");
		data.append("nonce", phpVals.btNonce);
		data.append("user", user);
		data.append("pass", pw);

		const params = new URLSearchParams(data);

		// Disable form controls and show loader
		toggleFormControls(form);

		clearFormError(form);

		wordPressRequest("POST", url, params)
			.then((data) => {
				if (data.api_response !== "error") {
					// User has logged in
					if (new URLSearchParams(location.search).get("action") !== "resetpass") {
						location.reload();
					} else {
						location = location.origin;
					}
				} else {
					// The login has returned an error, let's handle it
					console.error(data.message);

					toggleFormControls(form);
					setFormErrors(form, { ariaDescribedBy: "error-message" }, data.message);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	}

	function logoutRequest() {
		const url = phpVals.adminAjax;

		// Setup formdata
		let data = new FormData();
		data.append("action", "bt_user_logout");
		data.append("nonce", phpVals.btNonce);

		const params = new URLSearchParams(data);

		wordPressRequest("POST", url, params)
			.then((data) => {
				if (data.api_response !== "error") {
					// User has logged in
					location.reload();
				} else {
					// The login has returned an error, let's handle it
					console.error(data.message);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	}

	function clearFormError(form, options = { ariaDescribedBy: "" }, errorMessage = "") {
		const errorEl = form.querySelector("#error-message");
		errorEl.classList.add("opacity-0");
		errorEl.innerText = "";
		form.classList.remove("error");

		form.querySelectorAll("*:not(button)").forEach((el) => {
			el.setAttribute("aria-invalid", false);
			el.ariaDescribedBy = options.ariaDescribedBy;
			el.classList.remove("error");
		});
	}

	function setFormSuccess(form, options = { ariaDescribedBy: "" }, message = "") {
		const successEl = form.querySelector("#error-message");
		successEl.classList.remove("opacity-0");
		successEl.classList.remove("text-red");
		successEl.classList.add("text-green");
		successEl.innerText = message;
		form.classList.add("success");

		form.querySelectorAll("*:not(#error-message)").forEach((el) => {
			el.classList.add("!hidden");
		});
	}

	function setFormErrors(form, options = { ariaDescribedBy: "" }, errorMessage = "") {
		const errorEl = form.querySelector("#error-message");
		errorEl.classList.remove("opacity-0");
		errorEl.innerText = errorMessage;
		form.classList.add("error");

		form.querySelectorAll("*:not(button)").forEach((el) => {
			el.setAttribute("aria-invalid", true);
			el.ariaDescribedBy = options.ariaDescribedBy;
			el.classList.add("error");
		});
	}

	function toggleFormControls(form) {
		toggleFormButton(form);

		form.querySelectorAll("*:not(button)").forEach((el) => {
			el.toggleAttribute("disabled");
		});
	}

	function toggleFormButton(form) {
		const submitBtn = form.querySelector('[type="submit"]');
		const loader = submitBtn.querySelector(".loader");

		submitBtn.toggleAttribute("disabled");
		loader.classList.toggle("hidden");
	}

	function getCookie(name) {
		let documentCookie = document.cookie;
		let prefix = name + "=";
		let begin = documentCookie.indexOf("; " + prefix);
		let end;

		if (begin == -1) {
			begin = documentCookie.indexOf(prefix);
			if (begin != 0) return null;
		} else {
			begin += 2;
			end = document.cookie.indexOf(";", begin);
			if (end == -1) {
				end = documentCookie.length;
			}
		}

		return decodeURI(documentCookie.substring(begin + prefix.length, end));
	}

	function setCookie(cookieName, cookieValue, expiryDays) {
		const d = new Date();
		d.setTime(d.getTime() + expiryDays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
	}
})();
